import { useState, useEffect } from 'react'
import ProductCard from './ProductCard'
import './Catalog.css'

const getPageSize = () => window.innerWidth <= 768 ? 10 : 24

export default function Catalog({ products, waNumber }) {
  const [visible, setVisible] = useState(() => getPageSize())

  useEffect(() => {
    const handleResize = () => setVisible(getPageSize())
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const visibleProducts = products.slice(0, visible)
  const hayMas = visible < products.length
  const verMas = () => setVisible(prev => prev + getPageSize())

  if (products.length === 0) {
    return (
      <div className="catalog-empty">
        <p>No hay productos aún.</p>
        <p>Abre el panel de admin ⚙ para agregar productos.</p>
      </div>
    )
  }

  return (
    <div>
      <div className="catalog-grid">
        {visibleProducts.map(product => (
          <ProductCard
            key={product.id}
            product={product}
            waNumber={waNumber}
          />
        ))}
      </div>

      {hayMas && (
        <div className="catalog-ver-mas">
          <button className="btn-ver-mas" onClick={verMas}>
            Descubre más ({products.length - visible} restantes)
          </button>
        </div>
      )}
    </div>
  )
}